module.exports = __webpack_public_path__ + "assets/media/day7.d75b4041.mp3";